import { X } from 'lucide-react'
import { cn } from '../../lib/cn'

type ModalProps = {
  open: boolean
  onClose?: () => void
  children: React.ReactNode
  className?: string
}

export function Modal({ open, onClose, children, className }: ModalProps) {
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-foreground/40 sm:items-center sm:px-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        className={cn(
          'relative max-h-[90dvh] w-full overflow-y-auto rounded-t-3xl border-2 border-foreground bg-white p-6 shadow-xl sm:max-w-md sm:rounded-3xl sm:p-8',
          className,
        )}
        onClick={(event) => event.stopPropagation()}
      >
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full text-foreground/60 transition-colors hover:bg-stone hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2 sm:right-6 sm:top-6"
          >
            <X className="h-4 w-4" />
          </button>
        )}
        {children}
      </div>
    </div>
  )
}
